require('sass/blocks/_legal-info.scss');
// @ vendors
const React = require('react');
const { Fragment } = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
// @ actions
const initialActions = require('actions/initialActions');
const preLoaderActions = require('actions/preLoaderActions');
// @ commons
import { formatText, FormattedText } from 'core/i18n';
// @ components
const CustomScrollBar = require('components/customScrollBar/customScrollBar');
const ModalBox = require('components/modalBox/modalBox');
// @ utilities
const { mustShowLegalLinks, showLegalInfoByCountry } = require('utilities/logicByCountry');
const { generatePdf } = require('./helper/legalInfoHelper');
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
import { base64ToBlob, downloadAsFile } from 'utilities/APIRequestHelper';
// @ constants
const URL_PDF = 'https://www.openbank.es/assets/static/onboarding/pdf/';
// @ constants
const openbankLogo = require('assets/icons/logo-02.svg');
const { CREDIT_CARD } = require('constants/userProfile');
import { CONTENT_TYPE_PDF, PDF, BLOB_CONTENT_TYPE_PDF } from 'constants/APIRequestContants.js';
import { getPdfByPartnerId } from 'constants/creditCard/partners';

class LegalInfo extends React.Component {
    constructor(props) {
        super(props);
        this.dataProtectionPdf = `${URL_PDF}clausula_de_proteccion_de_datos_para_clientes_y_potenciales_clientes_openbank.pdf`;
        this.handleOnStartFileDownload = this.handleOnStartFileDownload.bind(this);
    }

    handleFileDownload() {
        const { initialStep, preLoaderActions } = this.props;

        if (initialStep.get('pdfDownloadLink')) {
            let linkName;
            if (initialStep.get('pdfDownloadLinkName')) {
                linkName = `${this.props.initialStep.get('pdfDownloadLinkName')}${PDF}`;
            } else {
                linkName = `${Math.floor(Date.now() / 1000)}${PDF}`;
            }

            const blob = base64ToBlob(`${BLOB_CONTENT_TYPE_PDF}${initialStep.get('pdfDownloadLink')}`);
            downloadAsFile(blob, CONTENT_TYPE_PDF, linkName);

            initialActions.clearPdf();
            preLoaderActions.hidePreLoader();
        }
    }

    handleOnStartFileDownload(precontractualesLinks) {
        const { initialActions, preLoaderActions } = this.props;
        preLoaderActions.showPreLoader();
        initialActions.getPdfMerge(precontractualesLinks, valid => {
            if (valid) {
                this.handleFileDownload();
            }
        });
    }

    getModalLegal(anchor) {
        const productsInfo = this.getProductsInfo();
        const productsInformation = productsInfo.productsInformation;

        return (
            <ModalBox
                bsSize="large"
                mainAction={this.onHandleMainAction}
                className="icons icons--icon-ancla"
                textButton=""
                width={800}
                textButtonClose={<FormattedText value="button-exitModal" />}
                modalLogo={<i className="icons icons--icon-openbank-logo"></i>}
                openButton={true}
                anchorNro={anchor}
            >
                <div className="legal-info__doc-block-modal">
                    <CustomScrollBar width="100%" autoHeightMin={495}>
                        <div>
                            <FormattedText value="documentation-gdprLegalInfo" injectedStrings={['', '']} />
                            <FormattedText value="documentation-precontractualInformation" injectedStrings={['']} />
                            {productsInformation}
                            {showLegalInfoByCountry() ? (
                                <Fragment>
                                    <FormattedText value="documentation-legalInfo2" injectedStrings={['4', '', '4']} />{' '}
                                    <FormattedText value="documentation-legalMiFID" injectedStrings={['5', '', '5']} />
                                </Fragment>
                            ) : (
                                <FormattedText value="documentation-legalMiFID" injectedStrings={['5', '', '4']} />
                            )}
                        </div>
                    </CustomScrollBar>
                </div>
            </ModalBox>
        );
    }

    getLegalIndex() {
        const legalPoints = 5;
        const array = [];
        for (let i = 1; i <= legalPoints; i++) {
            const text = `documentation-gdprLegalIndex${i}`;
            const anchor = `info_${i}`;
            const result = (
                <li key={i}>
                    <FormattedText value={text} />
                    <span className="legal-info__span">{this.getModalLegal(anchor)}</span>
                </li>
            );
            if (mustShowLegalLinks(i)) array.push(result);
        }

        return (
            <div>
                <FormattedText value="documentation-gdprLegalIndexTitle" />
                <div className="index-block">
                    <ul>{array}</ul>
                </div>
            </div>
        );
    }

    getProductsInfo(investmentType) {
        const { products } = this.props;
        const productsInfo = products.get('products');
        const linkArray = [];
        const urlsPdfs = [];
        let productsInformation;
        let i = 0;

        productsInfo.forEach(function (value) {
            urlsPdfs[i] = value.url;
            linkArray[i] = (
                <li key={value.id}>
                    <a href={value.url} target="_blank" className="legal-info-link" rel="noreferrer">
                        {value.description}
                    </a>
                </li>
            );
            i++;
        });

        productsInformation = (
            <div>
                <ul>{linkArray}</ul>
            </div>
        );

        const precontractualesLinks =
            investmentType === CREDIT_CARD
                ? [
                      getPdfByPartnerId(this.getPartnerId()),
                      'https://www.openbank.es/assets/static/pdf/Productos/Otros/Informacion_previa_contrato.pdf',
                  ]
                : generatePdf(urlsPdfs);

        return {
            productsInformation,
            precontractualesLinks,
        };
    }

    getPartnerId = () => this.props.products.get('partner').get('id');

    render() {
        const {
            userProfile: { investmentType },
        } = this.props;

        const handleOnStartFileDownload = this.handleOnStartFileDownload;
        const legalIndex = this.getLegalIndex();
        const productsInfo = this.getProductsInfo(investmentType);
        const productsInformation = productsInfo.productsInformation;
        const precontractualesLinks = productsInfo.precontractualesLinks;
        const userInvestmentType = checkUserInvestmentTypeAndReturnActiveOne(investmentType);

        return (
            <div>
                <div className="legal-info__doc-top">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="font-heading6--book">{formatText('fieldInfo-legal')}</div>
                        </div>
                    </div>
                </div>
                <div className="legal-info__doc-block">
                    <div className="row">
                        <div className="col-xs-6 legal-info__doc-block-logo">
                            <img src={openbankLogo} width={150} alt="openbank logo" />
                        </div>
                        <div className="col-xs-6 text-right">
                            <a id="downloadPdf" className="hidden"></a>
                            <a
                                href="#"
                                onClick={function (event) {
                                    event.preventDefault();
                                    handleOnStartFileDownload(precontractualesLinks);
                                }}
                            >
                                <i className="icons icons--icon-download"></i>
                            </a>
                            <ConditionalToggling condition={!userInvestmentType[CREDIT_CARD]}>
                                <ModalBox
                                    bsSize="large"
                                    mainAction={this.onHandleMainAction}
                                    className="icons icons--icon-expand"
                                    textButton=""
                                    width={800}
                                    textButtonClose={<FormattedText value="button-exitModal" />}
                                    modalLogo={<i className="icons icons--icon-openbank-logo"></i>}
                                >
                                    <div className="legal-info__doc-block-modal">
                                        <CustomScrollBar width="100%" autoHeightMin={495}>
                                            <div>
                                                <FormattedText
                                                    value="documentation-gdprLegalIndex"
                                                    injectedStrings={
                                                        showLegalInfoByCountry()
                                                            ? ['a', 'b', 'c', 'd', 'e']
                                                            : ['a', 'b', 'c', 'd']
                                                    }
                                                />
                                                <FormattedText
                                                    value="documentation-gdprLegalInfo"
                                                    injectedStrings={['a', 'b']}
                                                />
                                                <FormattedText
                                                    value="documentation-precontractualInformation"
                                                    injectedStrings={['c']}
                                                />
                                                {productsInformation}
                                                {showLegalInfoByCountry() ? (
                                                    <Fragment>
                                                        <FormattedText
                                                            value="documentation-legalInfo2"
                                                            injectedStrings={['4', 'd', '4']}
                                                        />{' '}
                                                        <FormattedText
                                                            value="documentation-legalMiFID"
                                                            injectedStrings={['5', 'e', '5']}
                                                        />
                                                    </Fragment>
                                                ) : (
                                                    <FormattedText
                                                        value="documentation-legalMiFID"
                                                        injectedStrings={['5', 'd', '4']}
                                                    />
                                                )}
                                            </div>
                                        </CustomScrollBar>
                                    </div>
                                </ModalBox>
                            </ConditionalToggling>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <CustomScrollBar width="100%" autoHeightMin={195}>
                                <ConditionalToggling condition={!userInvestmentType[CREDIT_CARD]}>
                                    <div>
                                        {legalIndex}
                                        <FormattedText
                                            value="documentation-gdprLegalInfo"
                                            injectedStrings={['1', '2']}
                                        />
                                        <FormattedText
                                            value="documentation-precontractualInformation"
                                            injectedStrings={['3']}
                                        />
                                        {productsInformation}
                                        {showLegalInfoByCountry() ? (
                                            <Fragment>
                                                <FormattedText
                                                    value="documentation-legalInfo2"
                                                    injectedStrings={['4', '4', '4']}
                                                />{' '}
                                                <FormattedText
                                                    value="documentation-legalMiFID"
                                                    injectedStrings={['5', '5', '5']}
                                                />
                                            </Fragment>
                                        ) : (
                                            <FormattedText
                                                value="documentation-legalMiFID"
                                                injectedStrings={['5', '5', '4']}
                                            />
                                        )}
                                    </div>
                                </ConditionalToggling>
                                <ConditionalToggling condition={userInvestmentType[CREDIT_CARD]}>
                                    <div>
                                        <FormattedText value={`documentation-creditCardInfo_${this.getPartnerId()}`} />
                                    </div>
                                </ConditionalToggling>
                            </CustomScrollBar>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports.constructor = LegalInfo;
module.exports.LegalInfo = connect(
    state => ({
        userProfile: state.userProfile,
        preLoader: state.preLoader,
        initialStep: state.initialStep,
        products: state.products,
    }),
    dispatch => ({
        initialActions: bindActionCreators(initialActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    })
)(LegalInfo);
